import {
  FACHINTERESSENT_BLOCKED_TENANTS,
  FACHINTERESSENT_CROSS_BU_ALLOWED,
  PORTAL_SWITCH_TENANT_IDS,
} from 'global/constants';

import { isFachinteressent } from './InstallerUtils';
import { getTenantIdByBU } from './tenantUtil';

const isFachinteressentBlockedTenant = (tenantId) =>
  FACHINTERESSENT_BLOCKED_TENANTS.includes(tenantId);

export const getFachinteressentAccessDenial = (installer, currentTenantId) => {
  if (isFachinteressentBlockedTenant(currentTenantId)) {
    return 'blocked_portal';
  }

  const { pflegendeBu } = installer;
  if (pflegendeBu == null) {
    return null;
  }

  const homeTenant = getTenantIdByBU(Number(pflegendeBu));
  if (!homeTenant) {
    return null;
  }

  if (isFachinteressentBlockedTenant(homeTenant)) {
    return 'blocked_home_bu';
  }

  if (homeTenant !== currentTenantId && !FACHINTERESSENT_CROSS_BU_ALLOWED[currentTenantId]) {
    return 'cross_bu_denied';
  }

  return null;
};

export const getPortalSwitchTenantIds = (installer) => {
  if (!installer || !isFachinteressent(installer)) {
    return PORTAL_SWITCH_TENANT_IDS;
  }

  return PORTAL_SWITCH_TENANT_IDS.filter((tenantId) => !isFachinteressentBlockedTenant(tenantId));
};

export const isFachinteressentRegistrationBlockedTenant = (tenantId) =>
  isFachinteressentBlockedTenant(tenantId);
